// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Material UI
import {CircularProgress, Dialog, DialogContent} from "@material-ui/core";

class ActionNotify extends Component {

    render() {
        const { handleClickToggle, handleAction, open, t, el, actualLayout } = this.props;
        return (
            <Dialog className="dialog_action" onClose={handleClickToggle} open={open}>
                <DialogContent>
                    <div>
                        <h4>{t(`frontend_info.${actualLayout}.title`)}</h4>
                        <p className="p2">{t(`frontend_info.${actualLayout}.description`)}</p>
                    </div>
                    <div className="btn-container">
                        <button className="btn btn-secondary"
                                onClick={handleClickToggle}>{t(`frontend_info.${actualLayout}.button_cancel`)}</button>
                        {
                            this.props.data.isSending ? (
                                <button className="btn btn-primary"><CircularProgress size={21}/></button>
                            ) : (
                                <button
                                    className={"btn btn-primary"}
                                    onClick={() => handleAction(el)}>{t(`frontend_info.${actualLayout}.button_action`)}</button>
                            )
                        }
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const notify = connect(
    mapStateToProps
)(ActionNotify);

export default withTranslation("notifications")(withRouter(notify));
